import Page from 'pages/Page'
import { FlexboxRows as FlexboxRowsPage } from 'pages'

const FlexboxRows = () => (
  <Page id="learn-css-flexbox-rows">
    <FlexboxRowsPage />
  </Page>
)

export default FlexboxRows